<template>
  <div id="mb-puzzle" class="mb-puzzle">
    <img
      v-if="startGameConfig.mainImage"
      @click="cancelCheck()"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <!-- <transition name="modal-fade">
      <preview-modal v-if="preview" @modal-off="preview = false" :img-src="startGameConfig.puzzle.src"></preview-modal>
    </transition>-->
    <svg width="0" height="0">
      <defs v-if="!yourBrowserSux">
        <filter id="shadow-in" filterUnits="objectBoundingBox" x="-0.1" y="-0.1" width="1.2" height="1.2">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2" result="alpha_blur" />
          <feOffset in="alpha_blur" dx="4" dy="4" result="offset_alpha_blur" />
          <feSpecularLighting
            in="alpha_blur"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="20"
            lighting-color="#FFFFFF"
            result="spec_light"
          >
            <fePointLight x="-5000" y="10000" z="10000" />
          </feSpecularLighting>
          <feComposite in="spec_light" in2="SourceAlpha" operator="in" result="spec_light" />
          <feComposite in="SourceGraphic" in2="spec_light" operator="out" result="spec_light_fill" />
          <feMerge>
            <feMergeNode in="offset_alpha_blur" />
            <feMergeNode in="spec_light_fill" />
          </feMerge>
        </filter>
        -->
        <clipPath
          :id="'clip' + indexClip"
          clipPathUnits="objectBoundingBox"
          :key="'puzzle-clip-path-' + indexClip"
          v-for="(puzzleClip, indexClip) in puzzle"
        >
          <path :d="puzzleClip.clipPath[0]" />
          <path :d="puzzleClip.clipPath[1]" />
          <path :d="puzzleClip.clipPath[2]" />
          <path :d="puzzleClip.clipPath[3]" />
        </clipPath>
      </defs>
    </svg>
    <div v-if="show && puzzle.length > 0" style="width: 100%; height: 100%">
      <div
        class="puzzle-grid"
        v-if="puzzle.length > 0"
        :style="{
          display: 'flex',
          'flex-flow': 'row wrap',
          'align-items': 'center',
          'justify-content': 'center',
        }"
      >
        <div
          :style="{
            'max-width':
              startGameConfig.puzzle.numerOfX * (puzzle[0].cropp.width - puzzle[0].cropp.widthPlus) + 2 + 'px',
            margin: 'auto',
            'max-height':
              startGameConfig.puzzle.numerOfY * (puzzle[0].cropp.height - puzzle[0].cropp.heightPlus) + 'px',
            display: 'flex',
            'flex-flow': 'row wrap',
            border: '1px solid rgba(255,255, 255, .6)',
            background: 'rgba(0, 0, 0, .15)',
          }"
        >
          <transition name="preview-fade">
            <div
              v-if="preview"
              :style="{
                position: 'absolute',
                width: startGameConfig.puzzle.numerOfX * (puzzle[0].cropp.width - puzzle[0].cropp.widthPlus) + 2 + 'px',
                margin: 'auto',
                height: startGameConfig.puzzle.numerOfY * (puzzle[0].cropp.height - puzzle[0].cropp.heightPlus) + 'px',
                background: 'white',
              }"
            >
              <img
                v-if="preview"
                class="preview-img"
                :style="{
                  width: '100%',
                  margin: 'auto',
                  height: '100%',
                  opacity: 0.5,
                }"
                :src="giveMeImagePlease(startGameConfig.puzzle.src)"
              />
            </div>
          </transition>
          <div
            :ref="'puzzle-grid-' + indexGrid"
            class="puzzle-grid-piece"
            :key="'puzzle-grid-' + indexGrid"
            v-for="(puzzleGrid, indexGrid) in puzzle"
            :style="{
              width: puzzleGrid.cropp.width - puzzleGrid.cropp.widthPlus - 0 + 'px',
              height: puzzleGrid.cropp.height - puzzleGrid.cropp.heightPlus - 0 + 'px',
              padding: 0,
              border: '1px solid rgba(255,255, 255, 1)',
            }"
          ></div>
          <div class="preview" @mouseenter="iconHover = true" @mouseleave="iconHover = false">
            <transition name="icon-fade">
              <img class="preview-icon" @click="preview = !preview" :src="previewIcon" />
            </transition>
            <transition name="icon-fade">
              <img class="preview-icon" v-if="iconHover" @click="preview = !preview" :src="previewIconOff" />
            </transition>
          </div>
        </div>
      </div>
      <vue-drag-resize
        class="puzzle-piece"
        :key="'crop-' + index"
        v-for="(crop, index) in puzzle"
        :is-resizable="false"
        :is-draggable="draggable"
        :is-active="false"
        :parent-limitation="true"
        :snap-to-grid="false"
        :w="crop.cropp.width"
        :h="crop.cropp.height"
        :x="crop.pos.x"
        :y="crop.pos.y"
        :z="crop.z"
        :parent-w="1920"
        :parent-scale-x="setWidthScale()"
        :parent-scale-y="setHeightScale()"
        :parent-h="1080"
        @clicked="setZIndex(index, 2)"
        @dragstop="
          resize($event, index);
          setZIndex(index, 1);
        "
        :style="setPuzzleStyle(crop, index)"
      >
        <cropp-image :img-config="crop" :style="setCroppImgStyle(index)"></cropp-image>
        <!-- <h1 style="position: absolute; color: green; top: 0; left: 80">{{ crop.correct }}</h1> -->
      </vue-drag-resize>
    </div>
    <div v-if="mbAudioInGameData.length > 0">
      <mb-audio-in-game
        :key="data.top + data.left + 'audio' + index"
        v-for="(data, index) in mbAudioInGameData"
        :item-data="data"
      ></mb-audio-in-game>
    </div>
  </div>
</template>
<script>
import { Howler } from 'howler';
// import PreviewModal from './Preview/PreviewModal';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
import CroppImage from '__mainSrcDir/components/CroppImage/CroppImage';
export default {
  name: 'mb-puzzle',
  components: { mbAudioInGame, CroppImage },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      yourBrowserSux: true,
      iconHover: false,
      mbAudioInGameData: [],
      draggable: true,
      currentImg: -1,
      audio: null,
      puzzle: [],
      correct: [],
      show: false,
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      canIPlayASong: true,
      canIClick: true,
      preview: false,
      currentPuzzle: -1,
      path: 'M .245,.755, .5,.5 .755,.755 .6,.755 C.65, 1 .35,1 .4,.755z',
    };
  },
  mounted() {
    this.audioInit();
    this.init();
    this.show = true;
  },
  methods: {
    setCroppImgStyle(index) {
      if (!this.yourBrowserSux)
        return {
          clipPath: 'url(#clip' + index + ')',
        };
    },
    setPuzzleStyle(it, index) {
      if (this.yourBrowserSux) {
        return {
          clipPath: it.clipPathString,
        };
      } else {
        return {
          clipPath: 'url(#clip' + index + ')',
          filter: 'url(#shadow-in)',
        };
      }
    },
    setWidthScale() {
      let itm = document.getElementById('mb-puzzle').getBoundingClientRect();
      return itm.width / 1920;
    },
    setHeightScale() {
      let itm = document.getElementById('mb-puzzle').getBoundingClientRect();
      return itm.height / 1080;
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    audioInit() {
      if (this.startGameConfig.audio) {
        if (this.startGameConfig.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
        if (this.startGameConfig.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfig.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
            onend: () => {
              this.canIPlayASong = true;
            },
            onstop: () => {
              this.canIPlayASong = true;
            },
            onplay: () => {
              this.canIPlayASong = false;
            },
          });
        }
      }
    },
    cancelCheck() {
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGameAction() {
      return this.puzzle.every((x) => x.correct == x.connected);
    },
    resetGameAction() {
      this.mbAudioInGameData = [];
      this.puzzle = [];
      this.correct = [];
      this.show = false;
      this.preview = false;
      this.draggable = true;
      this.$nextTick(() => {
        this.init();
      });

      this.show = true;
    },
    normalBrowserClipPathCreate(symbol, side) {
      if (side == 0) {
        //Left
        if (symbol == 0) {
          return 'M .245,.755 .5,.5 .245,.245 ';
        } else if (symbol == 1) {
          return 'M .245,.755 .5,.5 .245,.245 .245,.45 C0,.25 0,.75 .245,.55 ';
        } else if (symbol == 9) {
          return 'M .245,.755 .5,.5 .245,.245 .245,.46 C.50,.25 .50,.75 .245,.54 ';
        }
      } else if (side == 1) {
        //Top
        if (symbol == 0) {
          return 'M .755,.245 .5,.5 .245,.245 ';
        } else if (symbol == 1) {
          return 'M .755,.245 .5,.5 .245,.245 .45,.245 C.25, 0 .75,0 .55,.245 ';
        } else if (symbol == 9) {
          return 'M .755,.245 .5,.5 .245,.245 .46,.245 C.25,.50 .75,.50 .54,.245 ';
        }
      } else if (side == 2) {
        //Right
        if (symbol == 0) {
          return 'M .755,.755 .5,.5 .755,.245 .755,.6 ';
        } else if (symbol == 1) {
          return 'M .755,.755 .5,.5 .755,.245 .755,.45 C1,.25 1,.75 .755,.55 ';
        } else if (symbol == 9) {
          return 'M .755,.755 .5,.5 .755,.245 .755,.46 C.5,.25 .5,.75 .755,.54 ';
        }
      } else if (side == 3) {
        //Bot
        if (symbol == 0) {
          return 'M .245,.755, .5,.5 .755,.755 ';
        } else if (symbol == 1) {
          return 'M .245,.755, .5,.5 .755,.755 .55,.755 C.75, 1 .25,1 .45,.755 ';
        } else if (symbol == 9) {
          return 'M .245,.755, .5,.5 .755,.755 .54,.755 C.75, .50 .25,.50 .46,.755 ';
        }
      }
    },
    clipPathCreate(symbol, side, h, w) {
      if (side == 0) {
        //Left
        if (symbol == 0) {
          return (
            'M ' + w * 0.245 + ', ' + h * 0.755 + ' ' + w * 0.5 + ',' + h * 0.5 + ' ' + w * 0.245 + ',' + h * 0.245
          );
        } else if (symbol == 1) {
          return (
            'M ' +
            w * 0.245 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.45 +
            ' C' +
            w * 0 +
            ',' +
            h * 0.25 +
            ' ' +
            w * 0 +
            ',' +
            h * 0.75 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.55
          );
        } else if (symbol == 9) {
          return (
            'M ' +
            w * 0.245 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.46 +
            'C' +
            w * 0.5 +
            ',' +
            h * 0.25 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.75 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.54
          );
        }
      } else if (side == 1) {
        //Top
        if (symbol == 0) {
          return 'M ' + w * 0.755 + ',' + h * 0.245 + ' ' + w * 0.5 + ',' + h * 0.5 + ' ' + w * 0.245 + ',' + h * 0.245;
        } else if (symbol == 1) {
          return (
            'M ' +
            w * 0.755 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.45 +
            ',' +
            h * 0.245 +
            'C' +
            w * 0.25 +
            ',' +
            h * 0 +
            ' ' +
            w * 0.75 +
            ',' +
            h * 0 +
            ' ' +
            w * 0.55 +
            ',' +
            h * 0.245
          );
        } else if (symbol == 9) {
          return (
            'M ' +
            w * 0.755 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.245 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.46 +
            ',' +
            h * 0.245 +
            ' C' +
            w * 0.25 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.75 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.54 +
            ',' +
            h * 0.245
          );
        }
      } else if (side == 2) {
        //Right
        if (symbol == 0) {
          return (
            'M  ' +
            w * 0.755 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.6
          );
        } else if (symbol == 1) {
          return (
            'M ' +
            w * 0.755 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.45 +
            ' C' +
            w * 1 +
            ',' +
            h * 0.25 +
            ' ' +
            w * 1 +
            ',' +
            h * 0.75 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.55
          );
        } else if (symbol == 9) {
          return (
            'M ' +
            w * 0.755 +
            ', ' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.245 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.46 +
            'C' +
            w * 0.5 +
            ',' +
            h * 0.25 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.75 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.54
          );
        }
      } else if (side == 3) {
        //Bot
        if (symbol == 0) {
          return 'M ' + w * 0.245 + ',' + h * 0.755 + ' ' + w * 0.5 + ',' + h * 0.5 + ' ' + w * 0.755 + ',' + h * 0.755;
        } else if (symbol == 1) {
          return (
            'M ' +
            w * 0.245 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.55 +
            ',' +
            h * 0.755 +
            ' C' +
            w * 0.75 +
            ',' +
            h * 1 +
            ' ' +
            w * 0.25 +
            ',' +
            h * 1 +
            ' ' +
            w * 0.45 +
            ',' +
            h * 0.755
          );
        } else if (symbol == 9) {
          return (
            'M ' +
            w * 0.245 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.5 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.755 +
            ',' +
            h * 0.755 +
            ' ' +
            w * 0.54 +
            ',' +
            h * 0.755 +
            ' C' +
            w * 0.75 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.25 +
            ',' +
            h * 0.5 +
            ' ' +
            w * 0.46 +
            ',' +
            h * 0.755
          );
        }
      }
    },
    info(data) {
      // console.log(data);
    },
    setZIndex(index, z) {
      let it = this.puzzle[index];
      it.z = z;
      this.$set(this.puzzle, index, it);
    },
    checkPosition(x, y, index) {
      // //console.log(this.$refs['puzzle-grid-0']);
      if (this.audioClick) this.audioClick.play();
      let puzzleField = document.getElementsByClassName('puzzle-grid-piece');
      ////console.log(puzzleField);
      for (let i = 0; i < puzzleField.length; i++) {
        if (
          x >= parseInt(puzzleField[i].offsetLeft) &&
          x <= parseInt(puzzleField[i].offsetLeft) + parseInt(puzzleField[i].clientWidth) &&
          y >= parseInt(puzzleField[i].offsetTop) &&
          y <= parseInt(puzzleField[i].offsetTop) + parseInt(puzzleField[i].offsetTop)
        ) {
          ////console.log(i)
          if (!this.puzzle.some((x) => x.connected == i)) {
            this.puzzle[index].pos.x = puzzleField[i].offsetLeft - this.puzzle[index].cropp.widthPlus / 2;
            this.puzzle[index].pos.y = puzzleField[i].offsetTop - this.puzzle[index].cropp.heightPlus / 2;
            this.puzzle[index].connected = i;
            this.puzzle[index].z = 0;
          }
        }
      }
      if (this.checkGameAction()) {
        this.$store.dispatch('checkGame');
        this.draggable = false;
      }
    },
    resize(e, index) {
      let orginalPos = this.puzzle[index].pos;
      this.puzzle[index].pos.x = e.left;
      this.puzzle[index].pos.y = e.top;
      this.puzzle[index].connected = -1;
      ////console.log(e.left + this.puzzle[index].cropp.width / 2 + ' x ' + e.top + this.puzzle[index].cropp.height / 2);
      setTimeout(() => {
        this.checkPosition(
          e.left + this.puzzle[index].cropp.width / 2,
          e.top + this.puzzle[index].cropp.height / 2,
          index
        );
      }, 100);
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setPuzzle(w, h) {
      let tmpX = 0;
      let tmpY = 0;
      let tmpW = w / this.startGameConfig.puzzle.numerOfX;
      let tmpH = h / this.startGameConfig.puzzle.numerOfY;
      let puzzleStatic = null;
      if (this.startGameConfig.staticPuzzlePos) {
        puzzleStatic = this.shuffle(this.startGameConfig.staticPuzzlePos);
      }
      for (let i = 0; i < this.startGameConfig.puzzle.numerOfX * this.startGameConfig.puzzle.numerOfY; i++) {
        let tmpL;
        let tmpT;
        let tmpR;
        let tmpB;
        if (tmpX == this.startGameConfig.puzzle.numerOfX) {
          tmpY = tmpY + 1;
          tmpX = 0;
        }
        // 0
        if (tmpX == 0) {
          tmpL = '0';
        } else if (this.puzzle[i - 1].clipPathArray[2] == '1') {
          tmpL = '9';
        } else {
          tmpL = '1';
        }
        // 1
        if (tmpY == 0) {
          tmpT = '0';
        } else if (this.puzzle[i - this.startGameConfig.puzzle.numerOfX].clipPathArray[3] == '1') {
          tmpT = '9';
        } else {
          tmpT = '1';
        }
        // 2
        if (tmpX == this.startGameConfig.puzzle.numerOfX - 1) {
          tmpR = '0';
        } else {
          tmpR = this.getRandom('19');
        }
        //3
        if (tmpY == this.startGameConfig.puzzle.numerOfY - 1) {
          tmpB = '0';
        } else {
          tmpB = this.getRandom('19');
        }
        this.correct.push({ name: i, connect: -1 });
        let xPos = 0;
        let yPos = 0;
        if (puzzleStatic) {
          xPos = puzzleStatic[i].x;
          yPos = puzzleStatic[i].y;
        } else if (this.startGameConfig.staticPos) {
          if (this.startGameConfig.staticPos.x) {
            xPos = this.startGameConfig.staticPos.x[this.randomNumber(this.startGameConfig.staticPos.x.length, 0)];
          } else {
            xPos = this.randomNumber(1920 * 0.9 - tmpW, 0);
          }
          if (this.startGameConfig.staticPos.y) {
            yPos = this.startGameConfig.staticPos.y[this.randomNumber(this.startGameConfig.staticPos.y.length, 0)];
          } else {
            yPos = this.randomNumber(1080 * 0.9 - tmpH, 0);
          }
        } else {
          xPos = this.randomNumber(1920 * 0.9 - tmpW, 0);
          yPos = this.randomNumber(1080 * 0.9 - tmpH, 0);
        }
        this.puzzle.push({
          src: this.startGameConfig.puzzle.src,
          z: 1,
          cropp: {
            pos: {
              x: -1 * tmpW * tmpX + 0.5 * tmpW,
              y: -1 * tmpH * tmpY + 0.5 * tmpH,
              unit: 'px ',
            },
            width: tmpW + 1 * tmpW,
            widthPlus: 1 * tmpW,
            height: tmpH + 1 * tmpH,
            heightPlus: 1 * tmpH,
          },
          pos: {
            x: xPos,
            y: yPos,
            // x: tmpW * tmpX,
            // y: tmpH * tmpY,
          },
          //L T R B
          clipPathArray: tmpL + tmpT + tmpR + tmpB,
          clipPath: [
            this.normalBrowserClipPathCreate(tmpL, 0),
            this.normalBrowserClipPathCreate(tmpT, 1),
            this.normalBrowserClipPathCreate(tmpR, 2),
            this.normalBrowserClipPathCreate(tmpB, 3),
          ],
          clipPathString:
            'path("' +
            this.clipPathCreate(tmpL, 0, tmpH + 1 * tmpH, tmpW + 1 * tmpW) +
            this.clipPathCreate(tmpT, 1, tmpH + 1 * tmpH, tmpW + 1 * tmpW) +
            this.clipPathCreate(tmpR, 2, tmpH + 1 * tmpH, tmpW + 1 * tmpW) +
            this.clipPathCreate(tmpB, 3, tmpH + 1 * tmpH, tmpW + 1 * tmpW) +
            '")',
          correct: i,
        });
        tmpX = tmpX + 1;
      }
      this.puzzle = this.shuffle(this.puzzle);
    },
    init() {
      let tmpH;
      let tmpW;
      let img = new Image();
      // img.onload = (img) => {
      //   console.log(img);
      tmpH = this.startGameConfig.puzzle.height;
      tmpW = this.startGameConfig.puzzle.width;
      this.setPuzzle(tmpW, tmpH);
      // };
      if (this.startGameConfig.items) {
        let tmpItems = this.startGameConfig.items;
        this.shuffle(tmpItems);
        img.src = this.giveMeImagePlease(tmpItems[0].src);
        this.startGameConfig.puzzle = tmpItems[0];
      } else {
        img.src = this.giveMeImagePlease(this.startGameConfig.puzzle.src);
      }
      if (this.startGameConfig.puzzle.mbAudioItemData)
        this.mbAudioInGameData = this.startGameConfig.puzzle.mbAudioItemData;
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandom(letters) {
      let tmp = '';
      tmp += letters[Math.floor(Math.random() * letters.length)];
      return tmp;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    detectSystem() {
      var OSName = 'Unknown OS';
      if (navigator.appVersion.indexOf('Win') != -1) OSName = 'Windows';
      if (navigator.appVersion.indexOf('Mac') != -1) OSName = 'MacOS';
      if (navigator.appVersion.indexOf('X11') != -1) OSName = 'UNIX';
      if (navigator.appVersion.indexOf('Linux') != -1) OSName = 'Linux';
      return OSName;
    },
    detectBrowser() {
      let nAgt = navigator.userAgent;
      let browserName = navigator.appName;
      let nameOffset, verOffset;
      if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browserName = 'Opera';
      } else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browserName = 'Microsoft Internet Explorer';
      } else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browserName = 'Chrome';
      } else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browserName = 'Safari';
      } else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browserName = 'Firefox';
      } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      return browserName;
    },
  },
  beforeMount() {
    console.log(this.detectSystem());
    console.log(this.detectBrowser());
    if (
      (this.detectBrowser() == 'Chrome' || this.detectBrowser() == 'Opera') &&
      (this.detectSystem() == 'Windows' || this.detectSystem() == 'UNIX' || this.detectSystem() == 'Linux')
    )
      this.yourBrowserSux = false;
    else this.yourBrowserSux = true;
  },
  destroyed() {},
  computed: {
    previewIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/preview-64px.png`);
      } catch {
        console.log(
          '%cPreviewIcon MbPuzzle- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    previewIconOff() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/preview-off-64px.png`);
      } catch {
        console.log(
          '%cPreviewIconOff MbPuzzle- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-puzzle
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .puzzle-piece
    position: absolute
  .puzzle-grid
    position: absolute
    top: 0px
    width: 100%
    height: 100%
    left: 0
  .preview
    width: 64px
    height: 64px
    margin-left: calc(50% - 32px)
    margin-top: 1vh
    transition: .5s
    transform: scale(1)
    .preview-icon
      position: absolute
      top: 0
      left: 0
      cursor: pointer
    // &:hover
    //   transform: scale(1)
.vdr.active:before
  outline: none !important

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .1s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(1.5,1.5)
  opacity: 0

.preview-fade-leave-active, .preview-fade-enter-active
  transition: all .1s linear
.preview-fade-leave-to, .preview-fade-enter
  // transform: scale(.8,.8)
  opacity: 0
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
